import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import FlightDealTile from './FlightDealTile'
import { FlightDeal } from 'components/Flights/types'

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${rem(20)};

  ${mediaQueryUp.sm} {
    grid-template-columns: 1fr 1fr;
  }

  ${mediaQueryUp.md} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

interface Props {
  flightDeals: Array<FlightDeal>;
}

function FlightDealsList(props: Props) {
  const { flightDeals } = props

  return (
    <Root>
      {flightDeals.map(flightDeal =>
        <FlightDealTile
          key={flightDeal.id}
          flightDeal={flightDeal}
        />)
      }
    </Root>
  )
}

export default FlightDealsList
